module.exports = __webpack_public_path__ + "img/image-user-solid.1de77fb9.svg";